export default __webpack_public_path__ + "11fc22433c3ff7f92268ec8dce0e9227.svg";